module.exports = __webpack_public_path__ + "img/lsc_newsletter.6f66eb7c.jpeg";